export enum OrderType {
	IN_HOUSE_PART_ORDER = 1,
	PONIT_OF_SALE = 2,
	ONLINE_BOOKING = 3,
	ONLINE_STORE = 4,
	MEMBERSHIP = 5,
	TICKET_EVENT = 6,
	ONLINE_TICKET_EVENT = 7,
}

/**
 * True for a ticket event order of either channel: TICKET_EVENT is created in-house from
 * Management, ONLINE_TICKET_EVENT from the Consumer site. Ticket behaviour (receipt QR codes,
 * printing tickets) is the same for both, so always use this rather than comparing to a single
 * value - a bare `=== OrderType.TICKET_EVENT` silently excludes online orders.
 */
export const isTicketEventOrderType = (orderType?: number | null): boolean =>
	orderType === OrderType.TICKET_EVENT || orderType === OrderType.ONLINE_TICKET_EVENT;

export default OrderType;
